import React from 'react';
import AccountingModule from './accounting/Accounting';
const AccountsPayable = (props) => (React.createElement(AccountingModule, Object.assign({ ledgerType: "payables" }, props)));
export default AccountsPayable;
